"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const index_1 = require("../Icon/index");
const InfoBox = ({ text, onInfoMessageClose }) => {
    const [show, setShow] = React.useState(true);
    const handleClose = React.useCallback(() => {
        setShow(false);
        onInfoMessageClose();
    }, [onInfoMessageClose]);
    return show ? ((0, jsx_runtime_1.jsxs)("div", { className: "info-box", children: [(0, jsx_runtime_1.jsx)(index_1.Icon, { className: "icon icon-info-inverted" }), (0, jsx_runtime_1.jsx)("div", { className: "info-box-text", children: text }), (0, jsx_runtime_1.jsx)("span", { className: "icon icon-cancel", onClick: handleClose })] })) : null;
};
exports.InfoBox = InfoBox;
